export const Blockchain = {
  arbitrum: 'arbitrum',
  base: 'base',
  bitcoin: 'bitcoin',
  ethereum: 'ethereum',
  tron: 'tron',
} as const;

export type TBlockchain = keyof typeof Blockchain;

export const EActivityType = {
  ALL: 'all',
  NATIVE: 'native',
  ERC20: 'erc20',
  CONTRACT_CALL: 'contract_call',
} as const;

export type TActivityType = (typeof EActivityType)[keyof typeof EActivityType];
